import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams } from 'ionic-angular';

@Component({
  selector: 'page-holzalusysteme',
  templateUrl: 'holzalusysteme.html',
})
export class HolzalusystemePage {

  constructor(public navCtrl: NavController, public navParams: NavParams) {
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad HolzalusystemePage');
  }

}



// WEBPACK FOOTER //
// ./src/pages/holzalusysteme/holzalusysteme.ts